type TokenGetter = () => Promise<string>;

let getter: TokenGetter | null = null;

/** Registers the access-token getter used to authorize API requests. */
export const setAccessTokenGetter = (fn: TokenGetter | null) => {
  getter = fn;
};

// Returns null (rather than throwing) when a token can't be acquired, so the
// request still goes out and surfaces as a 401 the UI can render — the command
// API enforces auth in every environment, dev included.
export const getAccessToken = async () => {
  if (!getter) return null;
  try {
    return await getter();
  } catch {
    return null;
  }
};
